import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DateRange,
  extractDateRange,
  extractDefaultStoreId,
  extractNumber,
  HxProductService,
  HxUiLabelPipe,
  isoDate,
  ProductDiscardInfoModel,
  toRouterQueryParams
} from 'hx-services';
import { HxDateRangeSelectComponent, HxErrorHandlerService, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-product-discard-report.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './product-discard-report.component.html',
    styleUrls: ['./product-discard-report.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateRangeSelectComponent, NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, TranslocoPipe, HxUiLabelPipe]
})
export class ProductDiscardReportComponent implements OnInit, OnDestroy {
  list: ProductDiscardInfoModel[] = [];
  isLoading = {
    list: true
  };
  params: { date?: DateRange, storeId?: number } = {};
  private sub: Subscription;

  constructor(
    private productService: HxProductService,
    private errorHandlerService: HxErrorHandlerService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(Date.now()), to: isoDate(Date.now())};
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      this.loadList();
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private loadList() {
    this.isLoading.list = true;
    this.list = [];

    this.productService.getProductDiscards(this.params).subscribe(result => {
      this.list = result;
      this.isLoading.list = false;
    }, err => {
      this.errorHandlerService.check(err);
      this.isLoading.list = false;
    });
  }
}
